export default "<span class=\"pre-wrap\">\r\n  {{ translatedText }}\r\n</span>\r\n";